import React from "react";

interface Props {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
  greyScale?: boolean;
}

const PublisherControlButton = ({
  isActive,
  children,
  onClick,
  greyScale = false,
}: Props) => (
  <div>
    <button
      className={`${isActive && "active"} ${!greyScale && "colored"}`}
      type="button"
      onClick={onClick}
    >
      {children}
    </button>
    <style jsx>{`
      div {
        padding: 5px 2px;
      }
      button {
        border-radius: 50%;
        height: 35px;
        width: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 2px #a4a4a4;
        background: transparent;
        cursor: pointer;
      }
      .colored {
        background-color: #ee2444;
        color: white;
        border: none;
      }
      .active {
        background-color: #36ac4a;
        border: none;
      }
    `}</style>
  </div>
);

export default PublisherControlButton;
